<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-inner">
        <router-link to="/" class="nav-brand">💰 記帳本</router-link>
        <div class="nav-links">
          <router-link v-if="!isLoggedIn" to="/login" class="nav-btn nav-btn-primary">登入</router-link>
          <template v-if="isLoggedIn">
            <router-link to="/event">✏️ 記帳</router-link>
            <router-link to="/credit">💳 信用卡</router-link>
            <router-link to="/book">📖 帳本</router-link>
            <router-link to="/charts">📊 圖表</router-link>
            <router-link to="/assets">🏦 資產</router-link>
            <router-link to="/schedule">🗓️ 排程</router-link>
            <router-link to="/reminder">🔔 提醒<span v-if="unreadCount > 0" class="badge-count">{{ unreadCount }}</span></router-link>
            <router-link to="/stocks">📈 股票</router-link>
            <button @click="logout" class="nav-btn nav-btn-logout">登出</button>
          </template>
        </div>
      </div>
    </nav>
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';
export default {
  data() { return { unreadCount: 0 } },
  computed: {
    ...mapGetters(["isLoggedIn", "setToken"])
  },
  watch: {
    isLoggedIn(val) { if (val) this.fetchUnread() }
  },
  async mounted() {
    if (this.isLoggedIn) this.fetchUnread()
  },
  methods: {
    async fetchUnread() {
      try {
        const r = await axios.get('reminders', { headers: { Authorization: 'Bearer ' + this.$store.getters.setToken } })
        this.unreadCount = (r.data.reminders || []).filter(x => !x[3]).length
      } catch {}
    },
    logout() {
      this.$store.commit('setUser', null);
      this.$store.commit('setToken', null);
      localStorage.removeItem('setUser');
      localStorage.removeItem('setToken');
      this.$router.push('/login');
    }
  }
}
</script>
<style>
:root {
  --primary: #4f46e5;
  --primary-hover: #4338ca;
  --success: #059669;
  --danger: #dc2626;
  --warning: #d97706;
  --bg: #f3f4f6;
  --card: #ffffff;
  --text: #1f2937;
  --text-light: #6b7280;
  --border: #e5e7eb;
  --radius: 10px;
  --shadow: 0 1px 3px rgba(0,0,0,0.08), 0 1px 2px rgba(0,0,0,0.06);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.07), 0 2px 4px rgba(0,0,0,0.06);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: var(--bg);
  color: var(--text);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
}

#app {
  min-height: 100vh;
}

.navbar {
  background: var(--card);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow);
  position: sticky;
  top: 0;
  z-index: 100;
}

.nav-inner {
  max-width: 960px;
  margin: 0 auto;
  padding: 0 16px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-brand {
  font-size: 18px;
  font-weight: 700;
  color: var(--text);
  text-decoration: none;
}
.nav-brand:hover { color: var(--primary); }

.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
}

.nav-links a {
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-light);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.15s;
}
.nav-links a:hover {
  color: var(--primary);
  background: #eef2ff;
}
.nav-links a.router-link-exact-active {
  color: var(--primary);
  background: #eef2ff;
}

.nav-btn {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.nav-btn-primary {
  background: var(--primary);
  color: #fff;
}
.nav-btn-primary:hover { background: var(--primary-hover); }

.nav-btn-logout {
  background: none;
  color: var(--text-light);
  margin-left: 8px;
}
.nav-btn-logout:hover {
  color: var(--danger);
  background: #fef2f2;
}

.badge-count {
  display: inline-block;
  background: var(--danger);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 99px;
  padding: 0 5px;
  margin-left: 4px;
  line-height: 16px;
  min-width: 16px;
  text-align: center;
}

.main-content {
  max-width: 960px;
  margin: 0 auto;
  padding: 24px 16px;
}

/* Responsive */
@media (max-width: 640px) {
  .nav-links a { padding: 6px 10px; font-size: 13px; }
  .nav-inner { padding: 0 12px; }
  .main-content { padding: 16px 12px; }
}
</style>
